import { defineAction } from 'redux-define';

const moduleName = defineAction('APP');
export const TOGGLE_POSITION_OVERLAY = moduleName.defineAction('TOGGLE_POSITION_OVERLAY');
export const TOGGLE_MOBILE_HEADER_SEARCH = moduleName.defineAction('TOGGLE_MOBILE_HEADER_SEARCH');
